let authenticatedViewerPrefetchPromise = null;
let authenticatedViewerPrefetchScheduled = false;

const scheduleIdleTask = (callback) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  if (typeof window.requestIdleCallback === 'function') {
    const idleId = window.requestIdleCallback(callback, { timeout: 1500 });
    return () => window.cancelIdleCallback?.(idleId);
  }

  const timeoutId = window.setTimeout(callback, 250);
  return () => window.clearTimeout(timeoutId);
};

export const loadNewRecordViewer = () => import(
  /* webpackChunkName: "viewer-new-record" */
  '../containers/NewRecordViewer'
);

export const loadRecordViewer = () => import(
  /* webpackChunkName: "viewer-record" */
  '../containers/RecordViewer'
);

export const loadRecordViewerGuest = () => import(
  /* webpackChunkName: "viewer-guest" */
  /* webpackPrefetch: true */
  '../containers/RecordViewerGuest'
);

export const loadRecordViewerLink = () => import(
  /* webpackChunkName: "viewer-link" */
  /* webpackPrefetch: true */
  '../containers/RecordViewerLink'
);

export const loadRecordViewerPatient = () => import(
  /* webpackChunkName: "viewer-patient" */
  /* webpackPrefetch: true */
  '../containers/RecordViewerPatient'
);

export const prefetchAuthenticatedViewerShell = () => {
  if (!authenticatedViewerPrefetchPromise) {
    authenticatedViewerPrefetchPromise = Promise.all([
      loadNewRecordViewer(),
      loadRecordViewer(),
    ]).catch((error) => {
      authenticatedViewerPrefetchPromise = null;
      authenticatedViewerPrefetchScheduled = false;
      throw error;
    });
  }

  return authenticatedViewerPrefetchPromise;
};

export const scheduleAuthenticatedViewerPrefetch = () => {
  if (authenticatedViewerPrefetchScheduled || typeof window === 'undefined') {
    return;
  }

  authenticatedViewerPrefetchScheduled = true;

  const startPrefetch = () => {
    scheduleIdleTask(() => {
      prefetchAuthenticatedViewerShell().catch(() => {});
    });
  };

  if (document.readyState === 'complete') {
    startPrefetch();
    return;
  }

  window.addEventListener('load', startPrefetch, { once: true });
};
